import React, { useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Pager,
  Paging,
  Button,
  StateStoring,
  ColumnFixing,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import Guid from "devextreme/core/guid";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import axios from "axios";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import DateBox from "devextreme-react/date-box";
import SaleOrderMasterDetailView from "./SaleOrderMasterDetailView";
import ship_green from "../../assets/ship_green.svg";
import ship_red from "../../assets/ship_red.svg";
import OrderLogDataView from "./OrderLogItemView";
import Modal from "react-bootstrap/Modal";
import useDeviceSize from "../../hooks/useDeviceSize";
export function SalesOrderReportDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [salesOrderDataSource, setSalesOrderDataSource] = useState();
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);

  const classes = useStyles();
  const [GET_REFNO, SET_REFNO] = useState("");
  const [GET_BOOKNO, SET_BOOKNO] = useState("");
  const [GET_SMFREF, SET_SMFREF] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [consigneeList, setConsigneeList] = useState([]);
  const [selectConsignee, setSelectConsignee] = useState([]);
  const [getConsignee, setConsignee] = useState([]);
  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const [getSaleAuthenCode, setSaleAuthenCode] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState("");
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const formattedtoDay = date
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [getFlag, setFlag] = useState("");
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [logData, setLogData] = useState([]);
  useEffect(() => {
    setResult("");
    if (getUserRole == 1) {
      //fetchSale();
      //sales
      setButtonDisabled(true);
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserID,
      });
      setSaleAuthenCode(getEmpCode);
    } else if (getUserRole == 2) {
      //sales co
      setButtonDisabled(true);
      fetchSale();
      if (localStorage.getItem("getSelectSale")) {
        let sale = localStorage.getItem("getSelectSale");
        let sale_label = localStorage.getItem("getSelectSalelabel");
        setSelectSale(sale);
        setSale({ SALE_CODE: sale, SALE_NAME: sale_label });
      } else {
        setSelectSale("xxx");
      }
    } else if (getUserRole == 3 || getUserRole == 7 || getUserRole == 12 || getUserRole == 13) {
      setButtonDisabled(true);
      fetchSale();
      setUserID("");
    }
    if (localStorage.getItem("getSelectStatus")) {
      let stutus = localStorage.getItem("getSelectStatus");
      let stutus_label = localStorage.getItem("getSelectStatuslabel");
      setSelectStatus(stutus);
      setStatus({ value: stutus, label: stutus_label });
    }

    if (localStorage.getItem("getSelectShipper")) {
      let shipper = localStorage.getItem("getSelectShipper");
      let shipper_label = localStorage.getItem("getSelectShipperlabel");
      setSelectShipper(shipper);
      setShipper({ COM_CODE: shipper, COM_NAME: shipper_label });
    }
    if (localStorage.getItem("getSelectConsignee")) {
      let Consignee = localStorage.getItem("getSelectConsignee");
      let Consignee_label = localStorage.getItem("getSelectConsigneelabel");
      setSelectConsignee(Consignee);
      setConsignee({ COM_CODE: Consignee, COM_NAME: Consignee_label });
    }
    setSelectStatus(11)
       setStatus({ value: 11, label:  "Open Job" });
  }, []);
  const optionsStatus = [
    // { value: "0", label: "Draft" },
    { value: "1", label: "New" },
    { value: "2", label: "Received" },
    { value: "3", label: "Reject" },
    { value: "4", label: "Wait Carrier Release" },
    { value: "5", label: "Wait Sales to confirm" },
    { value: "6", label: "Sales confirm" },
    { value: "7", label: "BSE Created" },
    { value: "10", label: "BSE Confirmed" },
    { value: "11", label: "Open Job" },
    //{ value: "8", label: "BSE Pre Confirmed" },
    { value: "9", label: "Cancel" },
  ];
  const optionsButton = [
    { value: "1", label: "New FCL" },
    { value: "2", label: "New from BSE (FCL)" },
    { value: "3", label: "New LCL" },
    { value: "4", label: "New from BSE (LCL)" },
  ];
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
    localStorage.setItem("getSelectStatus", obj.value);
    localStorage.setItem("getSelectStatuslabel", obj.label);
  };
  const handleButtonNewChange = (obj) => {
    if (obj.value == "1") {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=fcl", "_blank");
    } else if (obj.value == "2") {
      window.open("/s-crm/SalesOrderForm?type=2&loadtype=fcl", "_blank");
    } else if (obj.value == "3") {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=lcl", "_blank");
    } else if (obj.value == "4") {
      window.open("/s-crm/SalesOrderForm?type=2&loadtype=lcl", "_blank");
    } else {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=fcl", "_blank");
    }
  };
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const handleSearch = (e) => {
    //setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    if (getUserRole == 1) {
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserID,
      });
      setSaleAuthenCode(getEmpCode);
    } else if (getUserRole == 3) {
      setSale([]);
      setSelectSale([]);
    }
    setStatus([]);
    setSelectStatus([]);
    setShipper([]);
    setSelectShipper([]);
    setConsignee([]);
    setSelectConsignee([]);
    setResult("");
    setDateStr("");
    setTotalCount(0);
    localStorage.removeItem("getSelectStatus");
    localStorage.removeItem("getSelectStatuslabel");
    localStorage.removeItem("getSelectShipper");
    localStorage.removeItem("getSelectShipperlabel");
    localStorage.removeItem("getSelectConsignee");
    localStorage.removeItem("getSelectConsigneelabel");
    localStorage.removeItem("getSelectSale");
    localStorage.removeItem("getSelectSalelabel");
    localStorage.removeItem("currentSelectedRowKeys");
  };

  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const urlSalesOrder =
    api_path +
    "/SALES_ORDER_REPORT.php?sale=" +
    selectSale +
    "&userid=" +
    getCrmId +
    "&userrole=" +
    getUserRole +
    "&shipper=" +
    selectShipper +
    "&cnee=" +
    selectConsignee +
    "&status=" +
    selectStatus +
    "&bookref=" +
    GET_REFNO +
    "&bookno=" +
    GET_BOOKNO +
    "&smfref=" +
    GET_SMFREF +
    "&parDateFrom=" +
    getDateFrom +
    "&parDateTo=" +
    getDateTo +
    "&load=" +
    getLoadGrid;
  useEffect(() => {
    setSalesOrderDataSource(
      new createStore({
        key: "ORDER_ID",
        loadUrl: `${urlSalesOrder}`,
      })
    );
  }, [urlSalesOrder]);

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const fetchSale = () => {
    axios
      .get(
        api_path + `/GET_SALES.php?role=` + getUserRole + `&user=` + getCrmId
      )
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
      localStorage.setItem("getSelectSale", obj.SALE_CODE);
      localStorage.setItem("getSelectSalelabel", obj.SALE_NAME);
    } else {
      setSelectSale([]);
      setSale([]);
      localStorage.removeItem("getSelectSale");
      localStorage.removeItem("getSelectSalelabel");
    }
  };
  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=SHIPPER`
      );
      const getst = resstate.json();
      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, [getSale.SALE_CODE]);
  const handleShipperChange = (obj) => {
    setSelectShipper(obj.COM_CODE);
    setShipper({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectShipper", obj.COM_CODE);
    localStorage.setItem("getSelectShipperlabel", obj.COM_NAME);
  };
  useEffect(() => {
    const getCNEEDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=CONSIGNEE`
      );
      const getst = resstate.json();
      setConsigneeList(await getst);
    };
    getCNEEDropdown().then();
  }, [getSale]);
  const handleConsigneeChange = (obj) => {
    setSelectConsignee(obj.COM_CODE);
    setConsignee({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectConsignee", obj.COM_CODE);
    localStorage.setItem("getSelectConsigneelabel", obj.COM_NAME);
  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    // delBooking(e.row.key);
    swal({
      title: "Are you sure to delete this order ?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        delBooking(e.row.key);
      }
    });
  }, []);
  const delBooking = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/TS_SALES_ORDER.php?order_id=${id}`
      );
      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };

  const onCopyButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderForm?copy_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderForm?order_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const onBookingButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderDetail?order_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SalesOrderReport_" +formattedtoDay+ ".xlsx"
        );
      });
    });
  };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (
        e.column.dataField === "ORDER_STATUS_NAME"
      ) {
        if (e.data.ORDER_STATUS === "0") {
            e.cellElement.innerHTML =
            "<p class='status" + e.data.ORDER_STATUS + "'>" + e.data.ORDER_STATUS_NAME +"</p>";
        } else {
            e.cellElement.innerHTML =
            "<p class='status" + e.data.ORDER_STATUS + "'>" + e.data.ORDER_STATUS_NAME +"</p>";
        }
      // } else if (e.column.dataField === "ORDER_NO") {
      //   e.cellElement.innerHTML =
      //     "<p style='color: #000;background-color: #EBEBEB;text-align:center;'><a href='SalesOrderDetail?order_id=" +
      //     e.row.key +
      //     "'  title='View Order' target='_blank' style='color: #000;'>" +
      //     e.data.ORDER_NO +
      //     "</a></p>";
      } else if (e.column.dataField === "ACTIVE_ITEM") {
        if (e.data.ACTIVE_ITEM === "1") {
          e.cellElement.innerHTML = "<img src=" + ship_green + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "2") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "3") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "0") {
          e.cellElement.innerHTML = "";
        } else {
          e.cellElement.innerHTML = "<img src=" + ship_green + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        }
      } else if (e.column.dataField === "INACTIVE_ITEM") {
        if (e.data.INACTIVE_ITEM === "1") {
          e.cellElement.innerHTML = "<img src=" + ship_red + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "2") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "3") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "0") {
          e.cellElement.innerHTML = "";
        } else {
          e.cellElement.innerHTML = "";
        }
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "FAK"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>📦  FAK</p>";
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "REEFER"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🧊 REEFER</p>";
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "FOOD"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🍽️ FOOD</p>";
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "GARMENT"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>👗 GARMENT</p>";
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "NAC"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>👨🏻‍💼 NAC</p>";
      } else if (
        e.column.dataField === "CARGO_TYPE" &&
        e.data.CARGO_TYPE == "DG"
      ) {
        e.cellElement.innerHTML = "<p style='text-align:left;'>☠️ DG</p>";
      } else if (
        e.column.dataField === "LOADTYPE" &&
        (e.data.LOADTYPE == "FCL" ||
          e.data.LOADTYPE == "DIRECT-FCL" ||
          e.data.LOADTYPE == "CONSOLE")
      ) {
        e.cellElement.innerHTML =
          "<p style='background-color: #ffd365;text-align:center;'>" +
          e.data.LOADTYPE +
          "</p>";
      } else if (
        e.column.dataField === "LOADTYPE" &&
        (e.data.LOADTYPE == "LCL" || e.data.LOADTYPE == "DIRECT-LCL")
      ) {
        e.cellElement.innerHTML =
          "<p style='background-color: #abffff;text-align:center;'>" +
          e.data.LOADTYPE +
          "</p>";
      }
    }
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);

  //end column chooser
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {}).format(value);
  const Search = () => {
    const [showResults, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );
  const customStyles = {
    control: (provided) => ({
      // class attribute : class=" css-i32vvf-control"
      ...provided,
      fontSize: 14,
      background: "#119f4a",
      color: "white",
      display: "flex",
      flexWrap: "nowrap",
      width: "15em",
    }),
    menu: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      background: "white",
      color: "#333",
    }),
    select: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
      color: "blue",
    }),
    option: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
    }),
    input: (provided) => ({
      ...provided,
      fontSize: 14,
      color: "white",
      width: "80px !important",
      border: "none",
      margin: "0px 0px 0px 0px",
    }),
  };
  // 3	Reject
  // 4	Wait Carrier Release
  // 5	Wait Sales to confirm
  // 6	Sales confirm
  // 7	BSE Created
  // 8	BSE PreConfirm
  // 10	BSE Confirmed
  // 9	Cancel
  // 11	Open Job
  // const isEdit = (ORDER_STATUS) =>
  //   ORDER_STATUS && ["6", "7", "8","10","11"].indexOf(ORDER_STATUS) >= 0;
  const isEdit = (ORDER_STATUS) =>
    ORDER_STATUS && ["11"].indexOf(ORDER_STATUS) >= 0;
  const isEditIconVisible = (e) => !isEdit(e.row.data.ORDER_STATUS);

  const isDel = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isDelelteIconVisible = (e) => isDel(e.row.data.ORDER_STATUS);

  const isCF = (status) =>
    status && ["5"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCFIconVisible = (e) => isCF(e.row.data.ORDER_STATUS);

  const isDraft = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCopyIconVisible = (e) => !isDraft(e.row.data.ORDER_STATUS);

  const isBooking = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isBookingIconVisible = (e) => isBooking(e.row.data.ORDER_STATUS);

  const onRefreshClick = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const updateGridData = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const renderDetailSection = useCallback(({ data }) => {
    return DetailSection(data, updateGridData);
  }, []);
  function onShowlogButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchItemData(e.row.key);
    setShowLog(true);
  }
  const showLogData = true;
  const fetchItemData = async (ORDER_ID) => {
    const response = await fetch(
      api_path + "/GET_ORDER_LOG.php?ORDER_ID=" + ORDER_ID
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (props.logData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">STATUS</th>
              <th scope="col">DATE</th>
              <th scope="col">Modified By</th>
              <th scope="col">DETAIL</th>
              <th scope="col">REMARK</th>
            </tr>
          </thead>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <OrderLogDataView
                    key={fdata.INQUIRY_ITEM_ID}
                    id={fdata.ORDER_ID}
                    STATUS_ID={fdata.STATUS_ID}
                    STATUS={fdata.STATUS}
                    USERNAME={fdata.USERNAME}
                    EVENT_DATE={fdata.EVENT_DATE}
                    DATE_TEXT={fdata.DATE_TEXT}
                    REMARK={fdata.REMARK}
                    REVISED_COLUMNS={fdata.REVISED_COLUMNS}
                  />
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  const [modeSize, setModeSize] = useState("widget");
  return (
    <Container maxWidth="xl">
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sales Order Log</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>

      
        <Grid item xs={12} sm={2}>
          <label>SALES</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>
     <Grid item xs={12} sm={2}>
          <label>Status</label>
          <Select
            className="react-select-container"
            placeholder="Select"
            value={getStatus}
            options={optionsStatus}
            onChange={handleStatusChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div className="labelError">{getResult}</div>
          <div className="labelResult">{getDateStr}</div>
          {/* <a onClick={onStateResetClick}>reset</a> the grid to its initial state. */}
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          id="SalesOrderContainer"
          onCellPrepared={cellPrepared}
          dataSource={salesOrderDataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="ORDER_ID"
          onExporting={onExporting}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
          //focusedRowEnabled={true}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>

          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="storageSalesOrderReport"
          />
          <ColumnFixing enabled={false} />
          <MasterDetail enabled={true} render={renderDetailSection} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="ORDER_ID"
            defaultSortOrder="desc"
            visible={false}
          />
          <Column
            dataField="ORDER_NO"
            caption="SO NO."
            width={80}
            allowResizing={false}
          />
          <Column
            dataField="ORDER_DATE"
            caption="SO Date"
            dataType="date"
            format="dd-MMM-yyyy"
            width={70}
            allowResizing={false}
          />
          <Column
            dataField="CUSTOMER_REF"
            caption="CUST. REF"
            width={100}
            allowResizing={false}
          />
          <Column dataField="SHIPPER_NAME" caption="Customer" width={180} />
          <Column dataField="CNEE_NAME" caption="CNEE" width={180} />
             <Column dataField="SHIPPING" caption="SHIPPING" width={180} />
                <Column dataField="TRUCKING" caption="TRUCKING" width={180} />
          <Column
            dataField="CNT20"
            caption="20'"
            allowResizing={true}
            width={60}
            alignment="center"
            visible={false} 
          />
          <Column
            dataField="CNT40"
            caption="40'"
            allowResizing={true}
            width={60}
            alignment="center"
            visible={false} 
          />
          <Column
            dataField="CNT40HQ"
            caption="40HQ"
            allowResizing={true}
            width={60}
            alignment="center"
            visible={false} 
          />
          <Column
            dataField="CNT45"
            caption="45'"
            allowResizing={true}
            width={60}
            alignment="center"
            visible={false} 
          />
             <Column dataField="BOOKNO"  />
                  <Column dataField="BSE_NO"  caption="DOCNO"/>
                   <Column dataField="HOUSE_BL"  />
                     <Column dataField="MASTER_BL"  />
          <Column dataField="POR" visible={false} />
          <Column dataField="POL" visible={false}  />
          <Column dataField="POD" visible={false}  />
          <Column dataField="DEL" visible={false}  />
          <Column dataField="FINAL" visible={false}  />
          <Column
            dataField="CARRIER_CODE"
            caption="CARRIER"
            width={100}
            visible={false}
          />
          <Column
            dataField="SERVICES_CONTRACT"
            caption="S/C"
            width={120}
            visible={false}
          />
          <Column
            dataField="CARGO_READY"
            caption="CRD"
            dataType="date"
            format="dd-MMM-yyyy"
            visible={false} 
          />
          <Column
            dataField="ETD_DATE"
            caption="ETD"
            dataType="date"
            format="dd-MMM-yyyy"
           visible={false} 
          />
          <Column
            dataField="ETA_DATE"
            caption="ETA"
            dataType="date"
            format="dd-MMM-yyyy"
            visible={false}
          />
          <Column
            dataField="CARGO_TYPE"
            caption="Cargotype"
            visible={false} 
            alignment="left"
          />
          <Column dataField="LOADTYPE" caption="Loadtype" visible={false}  />
          <Column
            dataField="INCOTERM"
            caption="Incoterm"
            visible={false} 
            alignment="center"
          />
          <Column dataField="ACTIVE_ITEM" caption="Active" width={65} visible={false}  />
          <Column dataField="INACTIVE_ITEM" caption="Inactive" width={50} visible={false} />
          <Column dataField="ORDER_STATUS_NAME" caption="Status" width={100} />
          <Column dataField="CREATE_BY" caption="Creater" width={80} />
       
          <Column dataField="CS_NAME" caption="CS" width={80} />
          <Column dataField="ORDER_STATUS" visible={false} />
          <Column dataField="TYPE20" visible={false} />
          <Column dataField="TYPE40" visible={false} />
          <Column dataField="TYPE40HQ" visible={false} />
          <Column dataField="TYPE45" visible={false} />
          <Column dataField="GW" visible={false} />
          <Column dataField="NO_OF_PACK" visible={false} />
          <Column dataField="PACKAGE_UNIT" visible={false} />
          <Column dataField="CBM" visible={false} />
          <Column dataField="BOOK_PRIORITY" visible={false} />
          <Column dataField="WAITING_FLAG" visible={false} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
const DetailSection = (data, updateGridData) => {
  return (
    <SaleOrderMasterDetailView
      ORDER_ID={data.ORDER_ID}
      ORDER_STATUS={data.ORDER_STATUS}
      SHIPPER_CODE={data.SHIPPER_CODE}
      CNEE_CODE={data.CNEE_CODE}
      CARRIER_CODE={data.CARRIER_CODE}
      SERVICES_CONTRACT={data.SERVICES_CONTRACT}
      BULLET_CODE={data.BULLET_CODE}
      SCAC={data.SCAC}
      CNT20={data.CNT20}
      CNT40={data.CNT40}
      CNT40HQ={data.CNT40HQ}
      CNT45={data.CNT45}
      GW={data.GW}
      BOOK_PRIORITY={data.BOOK_PRIORITY}
      WAITING_FLAG={data.WAITING_FLAG}
      POR={data.POR}
      POL={data.POL}
      POD={data.POD}
      DEL={data.DEL}
      FINAL={data.FINAL}
      INLAND_POSTCODE={data.INLAND_POSTCODE}
      USER_ID={data.USER_ID}
      sendDataToParent={updateGridData}
    />
  );
};
